module.exports = __webpack_public_path__ + "img/bg_delivery.dfbbee00.png";